import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import { AppProvider } from "./state.js";
import { applyTheme, loadTheme, watchSystemTheme } from "./theme.js";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);

// The service worker caches the app SHELL only. Snapshots are already in
// IndexedDB and must never be cached by the SW — they are decrypted data, and
// the Cache API is not where decrypted books belong.
applyTheme(loadTheme());
watchSystemTheme();

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
